import React from 'react';
import { User, Book, Award, MapPin } from 'lucide-react';

const AuthorPage = () => {
  return (
    <div>
      <section className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <div className="w-48 h-48 bg-gradient-to-br from-amber-500 to-amber-700 rounded-full mx-auto mb-8 flex items-center justify-center">
              <span className="text-6xl text-white font-bold">VG</span>
            </div>
            <h1 className="text-5xl font-bold mb-6">Victor Grösser</h1>
            <p className="text-2xl opacity-90">Author & Technology Entrepreneur</p>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold mb-8">About the Author</h2>
            <div className="prose prose-lg">
              <p className="text-lg text-gray-700 mb-6">
                Victor Grösser is a technology entrepreneur, writer, and cryptography enthusiast. 
                Born in Amsterdam and raised across Europe, he developed a fascination with codes, 
                puzzles, and hidden meanings from an early age.
              </p>
              <p className="text-lg text-gray-700 mb-6">
                With over a decade of experience in technology and artificial intelligence, Victor 
                brings a unique perspective to the thriller genre. His background in cryptography 
                and his love for historical mysteries combine to create The Lost Code Mystery.
              </p>
              <p className="text-lg text-gray-700 mb-8">
                When not writing, Victor runs several technology companies and continues to explore 
                the intersection of history, cryptography, and modern technology. He currently resides 
                in the Netherlands with his family.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
              <div className="text-center">
                <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Book className="w-8 h-8 text-amber-600" />
                </div>
                <h3 className="font-bold text-lg mb-2">The Lost Code Mystery</h3>
                <p className="text-gray-600">Debut Novel</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Award className="w-8 h-8 text-amber-600" />
                </div>
                <h3 className="font-bold text-lg mb-2">Technology Leader</h3>
                <p className="text-gray-600">10+ Years Experience</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <MapPin className="w-8 h-8 text-amber-600" />
                </div>
                <h3 className="font-bold text-lg mb-2">Based in Netherlands</h3>
                <p className="text-gray-600">Amsterdam</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AuthorPage;